module.exports = __webpack_public_path__ + "static/media/terminated_arrival_station_icon.e1fb33de.svg";